module.exports = __webpack_public_path__ + "img/nullgift.87030638.png";